import React from 'react'
// TODO move ui
// import { LayoutContent } from '@brainstud/schiphol-vtc-ui'
import { CurrentTemplate } from './'

const Rows = props => (
  // <LayoutContent
  //   main={
      <CurrentTemplate
        chapter={props.chapter}
        lesson={props.lesson}
        save={props.save}
        data={props.data} />
    // } />
)

export default Rows
